
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "step-3-retrieve-seek-profile"
    }}>{`Step 3: Retrieve SEEK Profile`}</h1>
    <p>{`Use the GraphQL `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/candidateProfile"
      }}><inlineCode parentName="a">{`candidateProfile`}</inlineCode>{` query`}</a>{` with the `}<inlineCode parentName="p">{`seek-prefill-id`}</inlineCode>{` from the `}<a parentName="p" {...{
        "href": "/use-cases/apply-with-seek/handle-authorization"
      }}>{`authorization flow`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "5": true,
        "20": true,
        "5550": true,
        "5723": true,
        "className": "language-scoobie-merged-code",
        "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query ($id: String!) {\\n  candidateProfile(id: $id) {\\n    profileId {\\n      value\\n    }\\n    candidate {\\n      person {\\n        name {\\n          formattedName\\n          given\\n          family\\n        }\\n        communication {\\n          email {\\n            address\\n          }\\n          phone {\\n            formattedNumber\\n          }\\n          address {\\n            formattedAddress\\n            city\\n            postalCode\\n            countryCode\\n          }\\n        }\\n      }\\n    }\\n    certifications {\\n      name\\n      effectiveTimePeriod {\\n        validTo\\n      }\\n      issued\\n      issuingAuthority {\\n        name\\n      }\\n      descriptions\\n    }\\n    education {\\n      educationDegrees {\\n        name\\n        date\\n        degreeGrantedStatus\\n      }\\n      institution {\\n        name\\n      }\\n      descriptions\\n    }\\n    employment {\\n      positionHistories {\\n        title\\n\\n        current\\n        start\\n        end\\n\\n        descriptions\\n      }\\n      organization {\\n        name\\n      }\\n    }\\n    executiveSummary\\n    personAvailability {\\n      immediateStartIndicator\\n      noticePeriodMeasure {\\n        unitCode\\n        value\\n      }\\n    }\\n    positionPreferences {\\n      locations {\\n        referenceLocation {\\n          formattedAddress\\n          city\\n          postalCode\\n          countryCode\\n        }\\n      }\\n      seekAnzWorkTypeCodes\\n      seekSalaryExpectations {\\n        amount {\\n          currency\\n          value\\n        }\\n        countryCode\\n        intervalCode\\n      }\\n    }\\n    qualifications {\\n      competencyName\\n    }\\n    attachments {\\n      descriptions\\n      seekRoleCode\\n      url\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":5,\"column\":1,\"offset\":135},\"end\":{\"line\":107,\"column\":4,\"offset\":1770},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"id\\\": \\\"globalPublicTest:candidateProfile:prefill:PoJo9PPLL9wEF6z5nvMP9d\\\"\\n}\",\"position\":{\"start\":{\"line\":109,\"column\":1,\"offset\":1772},\"end\":{\"line\":113,\"column\":4,\"offset\":1862},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"default\",\"value\":\"{\\n  \\\"candidateProfile\\\": {\\n    \\\"profileId\\\": {\\n      \\\"value\\\": \\\"globalPublicTest:candidateProfile:prefill:PoJo9PPLL9wEF6z5nvMP9d\\\"\\n    },\\n    \\\"candidate\\\": {\\n      \\\"person\\\": {\\n        \\\"name\\\": {\\n          \\\"formattedName\\\": \\\"Ella Greenholt\\\",\\n          \\\"given\\\": \\\"Ella\\\",\\n          \\\"family\\\": \\\"Greenholt\\\"\\n        },\\n        \\\"communication\\\": {\\n          \\\"email\\\": [\\n            {\\n              \\\"address\\\": \\\"EllaG@gmail.com\\\"\\n            }\\n          ],\\n          \\\"phone\\\": [\\n            {\\n              \\\"formattedNumber\\\": \\\"(02) 5550 5678\\\"\\n            }\\n          ],\\n          \\\"address\\\": [\\n            {\\n              \\\"formattedAddress\\\": \\\"Coober Pedy SA 5723 AU\\\",\\n              \\\"city\\\": \\\"Coober Pedy\\\",\\n              \\\"postalCode\\\": \\\"5723\\\",\\n              \\\"countryCode\\\": \\\"AU\\\"\\n            }\\n          ]\\n        }\\n      }\\n    },\\n    \\\"certifications\\\": [\\n      {\\n        \\\"name\\\": \\\"SA Drivers Licence\\\",\\n        \\\"effectiveTimePeriod\\\": {\\n          \\\"validTo\\\": \\\"2021-07\\\"\\n        },\\n        \\\"issued\\\": null,\\n        \\\"issuingAuthority\\\": null,\\n        \\\"descriptions\\\": []\\n      },\\n      {\\n        \\\"name\\\": \\\"Criminal History Check\\\",\\n        \\\"effectiveTimePeriod\\\": {\\n          \\\"validTo\\\": \\\"2023-01\\\"\\n        },\\n        \\\"issued\\\": \\\"2021-01\\\",\\n        \\\"issuingAuthority\\\": null,\\n        \\\"descriptions\\\": [\\\"Police check passed with no criminal history.\\\"]\\n      },\\n      {\\n        \\\"name\\\": \\\"Working with Children Check\\\",\\n        \\\"effectiveTimePeriod\\\": {\\n          \\\"validTo\\\": null\\n        },\\n        \\\"issued\\\": null,\\n        \\\"issuingAuthority\\\": {\\n          \\\"name\\\": \\\"Government of South Australia\\\"\\n        },\\n        \\\"descriptions\\\": []\\n      }\\n    ],\\n    \\\"education\\\": [\\n      {\\n        \\\"educationDegrees\\\": [\\n          {\\n            \\\"name\\\": \\\"Bachelor of Business Administration\\\",\\n            \\\"date\\\": \\\"2016-10\\\",\\n            \\\"degreeGrantedStatus\\\": \\\"Granted\\\"\\n          }\\n        ],\\n        \\\"institution\\\": {\\n          \\\"name\\\": \\\"Adelaide Business School\\\"\\n        },\\n        \\\"descriptions\\\": []\\n      },\\n      {\\n        \\\"educationDegrees\\\": [\\n          {\\n            \\\"name\\\": \\\"Masters of Business Administration\\\",\\n            \\\"date\\\": \\\"2018-07\\\",\\n            \\\"degreeGrantedStatus\\\": \\\"Granted\\\"\\n          }\\n        ],\\n        \\\"institution\\\": {\\n          \\\"name\\\": \\\"University of New South Wales\\\"\\n        },\\n        \\\"descriptions\\\": [\\\"3.8 GPA\\\"]\\n      }\\n    ],\\n    \\\"employment\\\": [\\n      {\\n        \\\"positionHistories\\\": [\\n          {\\n            \\\"title\\\": \\\"Customer Service Representative\\\",\\n            \\\"current\\\": false,\\n            \\\"start\\\": \\\"2015-05\\\",\\n            \\\"end\\\": \\\"2018-03\\\",\\n            \\\"descriptions\\\": [\\n              \\\"Gained front-line experience with customers to better understand their needs\\\"\\n            ]\\n          }\\n        ],\\n        \\\"organization\\\": {\\n          \\\"name\\\": \\\"Swift Inc\\\"\\n        }\\n      },\\n      {\\n        \\\"positionHistories\\\": [\\n          {\\n            \\\"title\\\": \\\"Customer Service Manager\\\",\\n            \\\"current\\\": true,\\n            \\\"start\\\": \\\"2018-10\\\",\\n            \\\"end\\\": null,\\n            \\\"descriptions\\\": [\\n              \\\"Grew a team of 5 CS representatives to 20 to meet the growing needs of the business.\\\"\\n            ]\\n          }\\n        ],\\n        \\\"organization\\\": {\\n          \\\"name\\\": \\\"Ledner Inc\\\"\\n        }\\n      }\\n    ],\\n    \\\"executiveSummary\\\": \\\"Dynamic customer service professional with an MBA, extensive management experience, and a strong focus on team building and stakeholder engagement.\\\",\\n    \\\"personAvailability\\\": {\\n      \\\"immediateStartIndicator\\\": false,\\n      \\\"noticePeriodMeasure\\\": {\\n        \\\"unitCode\\\": \\\"WEE\\\",\\n        \\\"value\\\": 2\\n      }\\n    },\\n    \\\"positionPreferences\\\": [\\n      {\\n        \\\"locations\\\": [],\\n        \\\"seekAnzWorkTypeCodes\\\": [\\\"ContractTemp\\\", \\\"FullTime\\\"],\\n        \\\"seekSalaryExpectations\\\": [\\n          {\\n            \\\"amount\\\": {\\n              \\\"currency\\\": \\\"AUD\\\",\\n              \\\"value\\\": 125000\\n            },\\n            \\\"countryCode\\\": \\\"AU\\\",\\n            \\\"intervalCode\\\": \\\"Year\\\"\\n          }\\n        ]\\n      }\\n    ],\\n    \\\"qualifications\\\": [\\n      {\\n        \\\"competencyName\\\": \\\"Team building\\\"\\n      },\\n      {\\n        \\\"competencyName\\\": \\\"Customer focus\\\"\\n      },\\n      {\\n        \\\"competencyName\\\": \\\"Stakeholder management\\\"\\n      }\\n    ],\\n    \\\"attachments\\\": [\\n      {\\n        \\\"descriptions\\\": [\\\"Candidate resume\\\"],\\n        \\\"seekRoleCode\\\": \\\"Resume\\\",\\n        \\\"url\\\": \\\"https://graphql.seek.com/globalPublicTest/prefillProfiles/PoJo9PPLL9wEF6z5nvMP9d/attachments/YXT9cL7CH84czqoR47Xbhc\\\"\\n      }\\n    ]\\n  }\\n}\",\"position\":{\"start\":{\"line\":115,\"column\":1,\"offset\":1864},\"end\":{\"line\":287,\"column\":4,\"offset\":6249},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]",
        "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query": true,
        "($id:": true,
        "String!)": true,
        "{\\n": true,
        "": true,
        "candidateProfile(id:": true,
        "$id)": true,
        "profileId": true,
        "value\\n": true,
        "}\\n": true,
        "candidate": true,
        "person": true,
        "name": true,
        "formattedName\\n": true,
        "given\\n": true,
        "family\\n": true,
        "communication": true,
        "email": true,
        "address\\n": true,
        "phone": true,
        "formattedNumber\\n": true,
        "address": true,
        "formattedAddress\\n": true,
        "city\\n": true,
        "postalCode\\n": true,
        "countryCode\\n": true,
        "certifications": true,
        "name\\n": true,
        "effectiveTimePeriod": true,
        "validTo\\n": true,
        "issued\\n": true,
        "issuingAuthority": true,
        "descriptions\\n": true,
        "education": true,
        "educationDegrees": true,
        "date\\n": true,
        "degreeGrantedStatus\\n": true,
        "institution": true,
        "employment": true,
        "positionHistories": true,
        "title\\n\\n": true,
        "current\\n": true,
        "start\\n": true,
        "end\\n\\n": true,
        "organization": true,
        "executiveSummary\\n": true,
        "personAvailability": true,
        "immediateStartIndicator\\n": true,
        "noticePeriodMeasure": true,
        "unitCode\\n": true,
        "positionPreferences": true,
        "locations": true,
        "referenceLocation": true,
        "seekAnzWorkTypeCodes\\n": true,
        "seekSalaryExpectations": true,
        "amount": true,
        "currency\\n": true,
        "intervalCode\\n": true,
        "qualifications": true,
        "competencyName\\n": true,
        "attachments": true,
        "seekRoleCode\\n": true,
        "url\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":5,\"column\":1,\"offset\":135},\"end\":{\"line\":107,\"column\":4,\"offset\":1770},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"id\\\":": true,
        "\\\"globalPublicTest:candidateProfile:prefill:PoJo9PPLL9wEF6z5nvMP9d\\\"\\n}\",\"position\":{\"start\":{\"line\":109,\"column\":1,\"offset\":1772},\"end\":{\"line\":113,\"column\":4,\"offset\":1862},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"default\",\"value\":\"{\\n": true,
        "\\\"candidateProfile\\\":": true,
        "\\\"profileId\\\":": true,
        "\\\"value\\\":": true,
        "\\\"globalPublicTest:candidateProfile:prefill:PoJo9PPLL9wEF6z5nvMP9d\\\"\\n": true,
        "},\\n": true,
        "\\\"candidate\\\":": true,
        "\\\"person\\\":": true,
        "\\\"name\\\":": true,
        "\\\"formattedName\\\":": true,
        "\\\"Ella": true,
        "Greenholt\\\",\\n": true,
        "\\\"given\\\":": true,
        "\\\"Ella\\\",\\n": true,
        "\\\"family\\\":": true,
        "\\\"Greenholt\\\"\\n": true,
        "\\\"communication\\\":": true,
        "\\\"email\\\":": true,
        "[\\n": true,
        "\\\"address\\\":": true,
        "\\\"EllaG@gmail.com\\\"\\n": true,
        "],\\n": true,
        "\\\"phone\\\":": true,
        "\\\"formattedNumber\\\":": true,
        "\\\"(02)": true,
        "5678\\\"\\n": true,
        "\\\"formattedAddress\\\":": true,
        "\\\"Coober": true,
        "Pedy": true,
        "SA": true,
        "AU\\\",\\n": true,
        "\\\"city\\\":": true,
        "Pedy\\\",\\n": true,
        "\\\"postalCode\\\":": true,
        "\\\"5723\\\",\\n": true,
        "\\\"countryCode\\\":": true,
        "\\\"AU\\\"\\n": true,
        "]\\n": true,
        "\\\"certifications\\\":": true,
        "\\\"SA": true,
        "Drivers": true,
        "Licence\\\",\\n": true,
        "\\\"effectiveTimePeriod\\\":": true,
        "\\\"validTo\\\":": true,
        "\\\"2021-07\\\"\\n": true,
        "\\\"issued\\\":": true,
        "null,\\n": true,
        "\\\"issuingAuthority\\\":": true,
        "\\\"descriptions\\\":": true,
        "[]\\n": true,
        "\\\"Criminal": true,
        "History": true,
        "Check\\\",\\n": true,
        "\\\"2023-01\\\"\\n": true,
        "\\\"2021-01\\\",\\n": true,
        "[\\\"Police": true,
        "check": true,
        "passed": true,
        "with": true,
        "no": true,
        "criminal": true,
        "history.\\\"]\\n": true,
        "\\\"Working": true,
        "Children": true,
        "null\\n": true,
        "\\\"Government": true,
        "of": true,
        "South": true,
        "Australia\\\"\\n": true,
        "\\\"education\\\":": true,
        "\\\"educationDegrees\\\":": true,
        "\\\"Bachelor": true,
        "Business": true,
        "Administration\\\",\\n": true,
        "\\\"date\\\":": true,
        "\\\"2016-10\\\",\\n": true,
        "\\\"degreeGrantedStatus\\\":": true,
        "\\\"Granted\\\"\\n": true,
        "\\\"institution\\\":": true,
        "\\\"Adelaide": true,
        "School\\\"\\n": true,
        "\\\"Masters": true,
        "\\\"2018-07\\\",\\n": true,
        "\\\"University": true,
        "New": true,
        "Wales\\\"\\n": true,
        "[\\\"3.8": true,
        "GPA\\\"]\\n": true,
        "\\\"employment\\\":": true,
        "\\\"positionHistories\\\":": true,
        "\\\"title\\\":": true,
        "\\\"Customer": true,
        "Service": true,
        "Representative\\\",\\n": true,
        "\\\"current\\\":": true,
        "false,\\n": true,
        "\\\"start\\\":": true,
        "\\\"2015-05\\\",\\n": true,
        "\\\"end\\\":": true,
        "\\\"2018-03\\\",\\n": true,
        "\\\"Gained": true,
        "front-line": true,
        "experience": true,
        "customers": true,
        "to": true,
        "better": true,
        "understand": true,
        "their": true,
        "needs\\\"\\n": true,
        "\\\"organization\\\":": true,
        "\\\"Swift": true,
        "Inc\\\"\\n": true,
        "Manager\\\",\\n": true,
        "true,\\n": true,
        "\\\"2018-10\\\",\\n": true,
        "\\\"Grew": true,
        "a": true,
        "team": true,
        "CS": true,
        "representatives": true,
        "meet": true,
        "the": true,
        "growing": true,
        "needs": true,
        "business.\\\"\\n": true,
        "\\\"Ledner": true,
        "\\\"executiveSummary\\\":": true,
        "\\\"Dynamic": true,
        "customer": true,
        "service": true,
        "professional": true,
        "an": true,
        "MBA,": true,
        "extensive": true,
        "management": true,
        "experience,": true,
        "and": true,
        "strong": true,
        "focus": true,
        "on": true,
        "building": true,
        "stakeholder": true,
        "engagement.\\\",\\n": true,
        "\\\"personAvailability\\\":": true,
        "\\\"immediateStartIndicator\\\":": true,
        "\\\"noticePeriodMeasure\\\":": true,
        "\\\"unitCode\\\":": true,
        "\\\"WEE\\\",\\n": true,
        "2\\n": true,
        "\\\"positionPreferences\\\":": true,
        "\\\"locations\\\":": true,
        "[],\\n": true,
        "\\\"seekAnzWorkTypeCodes\\\":": true,
        "[\\\"ContractTemp\\\",": true,
        "\\\"FullTime\\\"],\\n": true,
        "\\\"seekSalaryExpectations\\\":": true,
        "\\\"amount\\\":": true,
        "\\\"currency\\\":": true,
        "\\\"AUD\\\",\\n": true,
        "125000\\n": true,
        "\\\"AU\\\",\\n": true,
        "\\\"intervalCode\\\":": true,
        "\\\"Year\\\"\\n": true,
        "\\\"qualifications\\\":": true,
        "\\\"competencyName\\\":": true,
        "\\\"Team": true,
        "building\\\"\\n": true,
        "focus\\\"\\n": true,
        "\\\"Stakeholder": true,
        "management\\\"\\n": true,
        "\\\"attachments\\\":": true,
        "[\\\"Candidate": true,
        "resume\\\"],\\n": true,
        "\\\"seekRoleCode\\\":": true,
        "\\\"Resume\\\",\\n": true,
        "\\\"url\\\":": true,
        "\\\"https://graphql.seek.com/globalPublicTest/prefillProfiles/PoJo9PPLL9wEF6z5nvMP9d/attachments/YXT9cL7CH84czqoR47Xbhc\\\"\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":115,\"column\":1,\"offset\":1864},\"end\":{\"line\":287,\"column\":4,\"offset\":6249},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]": true
      }}>{`query ($id: String!) {
  candidateProfile(id: $id) {
    profileId {
      value
    }
    candidate {
      person {
        name {
          formattedName
          given
          family
        }
        communication {
          email {
            address
          }
          phone {
            formattedNumber
          }
          address {
            formattedAddress
            city
            postalCode
            countryCode
          }
        }
      }
    }
    certifications {
      name
      effectiveTimePeriod {
        validTo
      }
      issued
      issuingAuthority {
        name
      }
      descriptions
    }
    education {
      educationDegrees {
        name
        date
        degreeGrantedStatus
      }
      institution {
        name
      }
      descriptions
    }
    employment {
      positionHistories {
        title

        current
        start
        end

        descriptions
      }
      organization {
        name
      }
    }
    executiveSummary
    personAvailability {
      immediateStartIndicator
      noticePeriodMeasure {
        unitCode
        value
      }
    }
    positionPreferences {
      locations {
        referenceLocation {
          formattedAddress
          city
          postalCode
          countryCode
        }
      }
      seekAnzWorkTypeCodes
      seekSalaryExpectations {
        amount {
          currency
          value
        }
        countryCode
        intervalCode
      }
    }
    qualifications {
      competencyName
    }
    attachments {
      descriptions
      seekRoleCode
      url
    }
  }
}
`}</code></pre>
    <p>{`All SEEK Profile fields except for email address are optional.
Ensure that your software caters for an empty state:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-scoobie-merged-code",
        "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query ($id: String!) {\\n  candidateProfile(id: $id) {\\n    profileId {\\n      value\\n    }\\n    candidate {\\n      person {\\n        name {\\n          formattedName\\n          given\\n          family\\n        }\\n        communication {\\n          email {\\n            address\\n          }\\n          phone {\\n            formattedNumber\\n          }\\n          address {\\n            formattedAddress\\n            city\\n            postalCode\\n            countryCode\\n          }\\n        }\\n      }\\n    }\\n    certifications {\\n      name\\n      effectiveTimePeriod {\\n        validTo\\n      }\\n      issued\\n      issuingAuthority {\\n        name\\n      }\\n      descriptions\\n    }\\n    education {\\n      educationDegrees {\\n        name\\n        date\\n        degreeGrantedStatus\\n      }\\n      institution {\\n        name\\n      }\\n      descriptions\\n    }\\n    employment {\\n      positionHistories {\\n        title\\n\\n        current\\n        start\\n        end\\n\\n        descriptions\\n      }\\n      organization {\\n        name\\n      }\\n    }\\n    executiveSummary\\n    personAvailability {\\n      immediateStartIndicator\\n      noticePeriodMeasure {\\n        unitCode\\n        value\\n      }\\n    }\\n    positionPreferences {\\n      locations {\\n        referenceLocation {\\n          formattedAddress\\n          city\\n          postalCode\\n          countryCode\\n        }\\n      }\\n      seekAnzWorkTypeCodes\\n      seekSalaryExpectations {\\n        amount {\\n          currency\\n          value\\n        }\\n        countryCode\\n        intervalCode\\n      }\\n    }\\n    qualifications {\\n      competencyName\\n    }\\n    attachments {\\n      descriptions\\n      seekRoleCode\\n      url\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":292,\"column\":1,\"offset\":6368},\"end\":{\"line\":394,\"column\":4,\"offset\":8003},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"id\\\": \\\"globalPublicTest:candidateProfile:prefill:NviKaXd9grZUaWZx3NEy3m\\\"\\n}\",\"position\":{\"start\":{\"line\":396,\"column\":1,\"offset\":8005},\"end\":{\"line\":400,\"column\":4,\"offset\":8095},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"default\",\"value\":\"{\\n  \\\"candidateProfile\\\": {\\n    \\\"profileId\\\": {\\n      \\\"value\\\": \\\"globalPublicTest:candidateProfile:prefill:NviKaXd9grZUaWZx3NEy3m\\\"\\n    },\\n    \\\"candidate\\\": {\\n      \\\"person\\\": {\\n        \\\"name\\\": {\\n          \\\"formattedName\\\": \\\"\\\",\\n          \\\"given\\\": null,\\n          \\\"family\\\": null\\n        },\\n        \\\"communication\\\": {\\n          \\\"email\\\": [\\n            {\\n              \\\"address\\\": \\\"Hamish.Alexander@example.com\\\"\\n            }\\n          ],\\n          \\\"phone\\\": [],\\n          \\\"address\\\": []\\n        }\\n      }\\n    },\\n    \\\"certifications\\\": [],\\n    \\\"education\\\": [],\\n    \\\"employment\\\": [],\\n    \\\"executiveSummary\\\": null,\\n    \\\"personAvailability\\\": null,\\n    \\\"positionPreferences\\\": [],\\n    \\\"qualifications\\\": [],\\n    \\\"attachments\\\": []\\n  }\\n}\",\"position\":{\"start\":{\"line\":402,\"column\":1,\"offset\":8097},\"end\":{\"line\":436,\"column\":4,\"offset\":8830},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]",
        "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query": true,
        "($id:": true,
        "String!)": true,
        "{\\n": true,
        "": true,
        "candidateProfile(id:": true,
        "$id)": true,
        "profileId": true,
        "value\\n": true,
        "}\\n": true,
        "candidate": true,
        "person": true,
        "name": true,
        "formattedName\\n": true,
        "given\\n": true,
        "family\\n": true,
        "communication": true,
        "email": true,
        "address\\n": true,
        "phone": true,
        "formattedNumber\\n": true,
        "address": true,
        "formattedAddress\\n": true,
        "city\\n": true,
        "postalCode\\n": true,
        "countryCode\\n": true,
        "certifications": true,
        "name\\n": true,
        "effectiveTimePeriod": true,
        "validTo\\n": true,
        "issued\\n": true,
        "issuingAuthority": true,
        "descriptions\\n": true,
        "education": true,
        "educationDegrees": true,
        "date\\n": true,
        "degreeGrantedStatus\\n": true,
        "institution": true,
        "employment": true,
        "positionHistories": true,
        "title\\n\\n": true,
        "current\\n": true,
        "start\\n": true,
        "end\\n\\n": true,
        "organization": true,
        "executiveSummary\\n": true,
        "personAvailability": true,
        "immediateStartIndicator\\n": true,
        "noticePeriodMeasure": true,
        "unitCode\\n": true,
        "positionPreferences": true,
        "locations": true,
        "referenceLocation": true,
        "seekAnzWorkTypeCodes\\n": true,
        "seekSalaryExpectations": true,
        "amount": true,
        "currency\\n": true,
        "intervalCode\\n": true,
        "qualifications": true,
        "competencyName\\n": true,
        "attachments": true,
        "seekRoleCode\\n": true,
        "url\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":292,\"column\":1,\"offset\":6368},\"end\":{\"line\":394,\"column\":4,\"offset\":8003},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"id\\\":": true,
        "\\\"globalPublicTest:candidateProfile:prefill:NviKaXd9grZUaWZx3NEy3m\\\"\\n}\",\"position\":{\"start\":{\"line\":396,\"column\":1,\"offset\":8005},\"end\":{\"line\":400,\"column\":4,\"offset\":8095},\"indent\":[1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"default\",\"value\":\"{\\n": true,
        "\\\"candidateProfile\\\":": true,
        "\\\"profileId\\\":": true,
        "\\\"value\\\":": true,
        "\\\"globalPublicTest:candidateProfile:prefill:NviKaXd9grZUaWZx3NEy3m\\\"\\n": true,
        "},\\n": true,
        "\\\"candidate\\\":": true,
        "\\\"person\\\":": true,
        "\\\"name\\\":": true,
        "\\\"formattedName\\\":": true,
        "\\\"\\\",\\n": true,
        "\\\"given\\\":": true,
        "null,\\n": true,
        "\\\"family\\\":": true,
        "null\\n": true,
        "\\\"communication\\\":": true,
        "\\\"email\\\":": true,
        "[\\n": true,
        "\\\"address\\\":": true,
        "\\\"Hamish.Alexander@example.com\\\"\\n": true,
        "],\\n": true,
        "\\\"phone\\\":": true,
        "[],\\n": true,
        "[]\\n": true,
        "\\\"certifications\\\":": true,
        "\\\"education\\\":": true,
        "\\\"employment\\\":": true,
        "\\\"executiveSummary\\\":": true,
        "\\\"personAvailability\\\":": true,
        "\\\"positionPreferences\\\":": true,
        "\\\"qualifications\\\":": true,
        "\\\"attachments\\\":": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":402,\"column\":1,\"offset\":8097},\"end\":{\"line\":436,\"column\":4,\"offset\":8830},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}}]": true
      }}>{`query ($id: String!) {
  candidateProfile(id: $id) {
    profileId {
      value
    }
    candidate {
      person {
        name {
          formattedName
          given
          family
        }
        communication {
          email {
            address
          }
          phone {
            formattedNumber
          }
          address {
            formattedAddress
            city
            postalCode
            countryCode
          }
        }
      }
    }
    certifications {
      name
      effectiveTimePeriod {
        validTo
      }
      issued
      issuingAuthority {
        name
      }
      descriptions
    }
    education {
      educationDegrees {
        name
        date
        degreeGrantedStatus
      }
      institution {
        name
      }
      descriptions
    }
    employment {
      positionHistories {
        title

        current
        start
        end

        descriptions
      }
      organization {
        name
      }
    }
    executiveSummary
    personAvailability {
      immediateStartIndicator
      noticePeriodMeasure {
        unitCode
        value
      }
    }
    positionPreferences {
      locations {
        referenceLocation {
          formattedAddress
          city
          postalCode
          countryCode
        }
      }
      seekAnzWorkTypeCodes
      seekSalaryExpectations {
        amount {
          currency
          value
        }
        countryCode
        intervalCode
      }
    }
    qualifications {
      competencyName
    }
    attachments {
      descriptions
      seekRoleCode
      url
    }
  }
}
`}</code></pre>
    <p>{`Your software must tweak the supplied query to only select fields that it can currently pre-fill in production.
This simplifies your integration and reduces future maintenance overhead;
see `}<a parentName="p" {...{
        "href": "/graphql/in-practice#selecting-fields"
      }}>{`selecting fields`}</a>{` for more information.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/candidateProfile"
      }}><inlineCode parentName="a">{`candidateProfile`}</inlineCode>{` query`}</a>{` can only be called with the `}<inlineCode parentName="p">{`seek-prefill-id`}</inlineCode>{` for a short period after authorization;
subsequent calls will return a `}<a parentName="p" {...{
        "href": "/graphql/error-responses#forbidden"
      }}><inlineCode parentName="a">{`FORBIDDEN`}</inlineCode>{` response`}</a>{`.
If the candidate subsequently navigates to a different apply form in your software,
your software should start a new workflow and `}<a parentName="p" {...{
        "href": "/use-cases/apply-with-seek/display-button"
      }}>{`request a new Apply with SEEK button`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;